module.exports = __webpack_public_path__ + "static/media/IMG_0300.e5b5ca31.JPG";